import { CitySearchLanding } from 'components/search/CitySearchLanding';
import { CitySearchResults } from 'components/search/CitySearchResults';
import { FunctionComponent } from 'react';
import { GroupSearchLanding } from 'components/search/GroupSearchLanding';
import { GroupSearchResults } from 'components/search/GroupSearchResults';
import { Redirect, Route, useLocation } from 'react-router';
import { Switch } from 'react-router-dom';
import { ToGoSearchLanding } from 'components/search/ToGoSearchLanding';
import { TogoSearchResults } from 'components/search/TogoSearchResults';

const SearchRoute: FunctionComponent = () => {
  const location = useLocation();

  return (
    <Switch>
      <Route path="/group/:groupSlug/search">
        <GroupSearchResults />
      </Route>
      <Route path="/togo/search">
        <TogoSearchResults />
      </Route>
      <Route path="/city/:citySlug/search" component={CitySearchResults} />
      <Route path="/city/:citySlug" component={CitySearchLanding} />
      <Route path="/group/:groupSlug" component={GroupSearchLanding} />
      <Route path="/togo" component={ToGoSearchLanding} />
      <Redirect from="/:type(city|group)" to={{ ...location, pathname: '/' }} />
    </Switch>
  );
};

export default SearchRoute;
